import {
  type FilterType,
  FilterTypes,
  type FilterValues,
  createDateRangeFilterValidators,
  filterToPostGraphileFilter,
  transformRange,
} from '@axinom/mosaic-ui';
import type { DeploymentData, ExplorerFilters } from './RowExplorer.types';

export function useRowDataFilters(
  type: string,
  _excludeItems: DeploymentData['id'][] | undefined,
): {
  readonly filterOptions: FilterType<DeploymentData>[];
  readonly transformFilters: (
    filters: FilterValues<DeploymentData>,
  ) => ExplorerFilters | undefined;
} {
  const [createFromDateFilterValidator, createToDateFilterValidator] =
    createDateRangeFilterValidators<DeploymentData['id']>();

  const generateFilterTypes = (): FilterType<DeploymentData>[] => {
    let options: FilterType<DeploymentData['id']>[] | undefined = [];
    if (type === 'ContainerImage') {
      options = [
        {
          label: 'Container Image Version',
          property: 'containerImageVersion',
          type: FilterTypes.FreeText,
        },
        {
          label: 'Deployment State',
          property: 'usedInActiveDeployment',
          type: FilterTypes.Options,
          options: [
            {
              label: 'Deployed',
              value: true,
            },
            {
              label: 'Not Deployed',
              value: false,
            },
          ],
        },
      ];
    } else if (type === 'ServicePiletArtifacts') {
      options = [
        {
          label: 'Package Name',
          property: 'name',
          type: FilterTypes.FreeText,
        },
        {
          label: 'Package Version',
          property: 'packageVersion',
          type: FilterTypes.FreeText,
        },
        {
          label: 'Deployment State',
          property: 'usedInActiveDeployment',
          type: FilterTypes.Options,
          options: [
            {
              label: 'Deployed',
              value: true,
            },
            {
              label: 'Not Deployed',
              value: false,
            },
          ],
        },
      ];
    } else if (type === 'ServiceDeploymentManifest') {
      options = [
        {
          label: 'Name',
          property: 'name',
          type: FilterTypes.FreeText,
        },
        {
          label: 'Deployment State',
          property: 'usedInActiveDeployment',
          type: FilterTypes.Options,
          options: [
            {
              label: 'Deployed',
              value: true,
            },
            {
              label: 'Not Deployed',
              value: false,
            },
          ],
        },
        {
          label: 'Creation Period (From)',
          property: 'createdDate',
          type: FilterTypes.Date,
          onValidate: createFromDateFilterValidator('createdDate'),
        },
        {
          label: 'Creation Period (To)',
          property: 'createdDate',
          type: FilterTypes.Date,
          onValidate: createToDateFilterValidator('createdDate'),
        },
      ];
    } else {
      options = [];
    }
    return options;
  };

  const transformFilters = (
    filters: FilterValues<DeploymentData>,
  ): ExplorerFilters | undefined => {
    return filterToPostGraphileFilter<ExplorerFilters>(filters, {
      name: 'includesInsensitive',
      packageVersion: 'includesInsensitive',
      id: 'equalTo',
      repositoryName: 'includesInsensitive',
      createdDate: transformRange,
    });
  };

  const filterOptions = generateFilterTypes();
  return { filterOptions, transformFilters };
}
